(function ($) {
    $(document).ready(function () {
        let $cur_button = $(".rank-math-question").first(); // Первый вопрос открыт
        let $bef_button = 0;

        // Открываем первый ответ, добавляем классы
        $(".rank-math-answer").hide().removeClass("opened"); // Все закрываем
        $(".rank-math-answer").first().show().addClass("opened"); // Первый оставляем открытым
        $(".rank-math-question").first().addClass("clicked"); // Первый вопрос активен

        $(".rank-math-question").click(function () {
            if ($cur_button.length) {
                $bef_button = $cur_button;
                $cur_button = $(this);
            } else {
                $cur_button = $(this);
            }

            if ($(this).next().is(":hidden")) {
                $(".rank-math-answer").slideUp().removeClass("opened"); // ❌ Закрываем все и удаляем "opened"
                $($bef_button).removeClass("clicked");
                $(this).addClass("clicked");
                $(this).next().slideDown().addClass("opened"); // ✅ Добавляем "opened"
            } else {
                $(this).next().slideUp().removeClass("opened"); // ✅ Убираем "opened" при закрытии
                $(this).removeClass("clicked");
            }
        });
    });

    $(".filter-show").click(function () {
        $(".filter-list").toggleClass("filter-list--active");
    });

    lazyLoad();
})(jQuery);
